import React from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import RecordAttachmentsCard from '../components/RecordAttachmentsCard'
import type { WriteResult } from '../hooks/useCostWriteQueue'
import type { CostRfqQuote } from '../types'

interface Props {
  /** The quote whose files are shown; null closes the dialog. */
  quote: CostRfqQuote | null
  projectId: string
  canAdd: boolean
  canRemove: boolean
  canLinkDocuments: boolean
  onClose: () => void
  onAdd: (quoteId: string, source: { fileId: string } | { docRevisionId: string }) => Promise<WriteResult>
  onRemove: (attachmentId: string) => Promise<WriteResult>
}

/** Part D spec §8: a quote's files (the PDF of the offer) in the module's existing attachments card. */
const QuoteAttachmentsDialog: React.FC<Props> = ({ quote, projectId, canAdd, canRemove, canLinkDocuments, onClose, onAdd, onRemove }) => {
  const { t } = useTranslation()
  return (
    <Dialog open={!!quote} onOpenChange={(next) => { if (!next) onClose() }}>
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>{quote ? t('CostControl_rfq_attachments_quote_title', { supplier: quote.supplierName }) : ''}</DialogTitle>
        </DialogHeader>
        {quote && (
          <RecordAttachmentsCard
            projectId={projectId}
            attachments={quote.attachments}
            canAdd={canAdd}
            canRemove={canRemove}
            canLinkDocuments={canLinkDocuments}
            onAdd={(source) => onAdd(quote.id, source)}
            onRemove={onRemove}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
export default QuoteAttachmentsDialog
